// ⚡ Performance Detection & Optimization Utilities
// Détecte les capacités de l'appareil et optimise les animations

import { gsap } from 'gsap';

/**
 * 🔍 Détecte les capacités de performance de l'appareil
 * @returns {Object} Configuration d'optimisation
 */
export const detectPerformanceCapabilities = () => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isLowEndDevice = navigator.hardwareConcurrency <= 2;
  const isSlowConnection = navigator.connection?.effectiveType === 'slow-2g' || navigator.connection?.effectiveType === '2g';
  const isLowMemory = navigator.deviceMemory <= 2;
  const isLowBattery = navigator.getBattery ? false : false; // Simplified for compatibility

  // 🎯 Critères de réduction des animations
  const shouldReduceAnimations = isMobile || isLowEndDevice || isSlowConnection || isLowMemory;
  const shouldDisableParticles = isLowEndDevice && isMobile;

  return {
    isMobile,
    isLowEndDevice,
    isSlowConnection,
    isLowMemory,
    isLowBattery,
    shouldReduceAnimations,
    shouldDisableParticles,
    // 🎮 Configuration recommandée
    recommendedFPS: shouldReduceAnimations ? 30 : 60,
    maxParticles: shouldReduceAnimations ? 6 : 12,
    animationDuration: shouldReduceAnimations ? 0.3 : 0.6
  };
};

/**
 * ⚙️ Configuration d'animation adaptative
 * @param {Object} capabilities - Résultat de detectPerformanceCapabilities
 * @returns {Object} Configuration GSAP
 */
export const getAnimationConfig = (capabilities) => {
  if (capabilities.shouldReduceAnimations) {
    return {
      duration: 0.3,
      ease: "power2.out",
      force3D: true,
      stagger: 0.1
    };
  }
  
  return {
    duration: 0.6,
    ease: "power3.out", 
    force3D: true,
    stagger: 0.15
  };
};

/**
 * 🚀 Optimise GSAP selon les capacités de l'appareil
 * @param {Object} capabilities - Résultat de detectPerformanceCapabilities
 */
export const optimizeGSAP = (capabilities) => {
  // 🎯 Configuration globale GSAP
  const config = getAnimationConfig(capabilities);
  
  gsap.defaults({
    duration: config.duration,
    ease: config.ease,
    force3D: config.force3D
  });

  // 🔄 Ajuster la fréquence d'images
  if (capabilities.shouldReduceAnimations) {
    gsap.ticker.fps(capabilities.recommendedFPS);
  }
};